import { api, withFallback } from "./api";
import { PROMOTIONS } from "../data/promotions";

export const promotionService = {
  list: () => withFallback(() => api.get("/promotions"), PROMOTIONS),
  active: () =>
    withFallback(() => api.get("/promotions/active"), PROMOTIONS.filter((p) => p.active)),
};
